import React, { useState, useEffect } from "react";

export default function ScrollHooks() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    console.log("Fase de Actualizacion Mov Scroll");

    const detectarScroll = () => setScrollY(window.pageYOffset);

    window.addEventListener("scroll", detectarScroll);

    // myObject.addEventListener('myCustomEventTypeString', handler);
    // myObject.dispatchEvent(new Event('myCustomEventTypeString'));
    // myObject.removeEventListener('myCustomEventTypeString', handler);

// *******************************    
//   var VN1 = this.name.substring(this.name.lastIndexOf("_")+1);
//     var objLocal1 = {};
//     objLocal1.pw1   = 0;

//     if(objLocal1.pw1==0){objLocal1.pw1=1} else {objLocal1.pw1=0};
	
//     document.dispatchEvent(new CustomEvent(VN1, {detail: {name: VN1, values: JSON.stringify(objLocal1) }  }));
//     document.dispatchEvent(new CustomEvent("mqtt1Send1", {detail: { name: VN1, values: JSON.stringify(objLocal1) } }));

//     document.addEventListener(VN1, ChangeValue);
// function ChangeValue(event){
// 	objLocal1 = JSON.parse(event.detail.values);	
//   _this.SW.gotoAndStop(parseInt(objLocal1.pw1));		
// }

// document.addEventListener("mqtt1Conectado1", processEvent4);
// function processEvent4(event){
//   document.dispatchEvent(new CustomEvent("mqtt1Sub1", {detail: { name: VN1, value: 0 }}));
// }


// // called when a message arrives
// function onMessageArrived(message) {
// 	_this.SocketRx1.gotoAndStop(1);
// 	ledrx = setTimeout(led_rxoff, 150);
// 	document.dispatchEvent(new CustomEvent(message.destinationName, {detail: { name: message.destinationName, values: message.payloadString }}));	
// }

// function led_rxoff() {
//   _this.SocketRx1.gotoAndStop(0);
//  }
 

// ********************************
    return () => {
      window.removeEventListener("scroll", detectarScroll);
    };
  }, [scrollY]);

  useEffect(() => {
    console.log("Fase de Montaje");
  }, []);

  useEffect(() => {
    console.log("Fase de Actualizacion");
  });

  useEffect(() => {
    return () => {
      console.log("Fase de Desmontaje");
    };
  });

  return (
    <>
      <h2>Hookl - useEffect y el ciclo de vida</h2>
      <p>Scroll y del Navegador {parseInt(scrollY)}px </p>
    </>
  );
}
